const _cache = new Map();

export async function fetchWikiThumb(pageTitle) {
  if (!pageTitle) return null;
  if (_cache.has(pageTitle)) {
    const v = _cache.get(pageTitle);
    return v instanceof Promise ? await v : v;
  }
  const p = (async () => {
    try {
      const url = `https://pt.wikipedia.org/api/rest_v1/page/summary/${encodeURIComponent(pageTitle)}`;
      const res = await fetch(url, { mode: "cors" });
      if (!res.ok) return null;
      const data = await res.json();
      return data.originalimage?.source || data.thumbnail?.source || null;
    } catch { return null; }
  })();
  _cache.set(pageTitle, p);
  const r = await p;
  _cache.set(pageTitle, r);
  return r;
}
